<script setup>
import { SelectRoot, useForwardPropsEmits } from "reka-ui";

const props = defineProps({
  modelValue: { type: [String, Number, Boolean, Object], default: undefined },
  defaultValue: { type: [String, Number, Boolean, Object], default: undefined },
  open: { type: Boolean, default: undefined },
  defaultOpen: { type: Boolean, default: undefined },
  dir: { type: String, default: undefined },
  name: { type: String, default: undefined },
  autocomplete: { type: String, default: undefined },
  disabled: { type: Boolean, default: undefined },
  required: { type: Boolean, default: undefined },
});

const emits = defineEmits(["update:modelValue", "update:open"]);

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
  <SelectRoot v-bind="forwarded" data-slot="select" v-slot="slotProps">
    <slot v-bind="slotProps" />
  </SelectRoot>
</template>
